<template>
  <div class="main-close-messages d-flex">
    <v-alert
      :border="getParam('border')"
      :colored-border="getParam('coloredBorder')"
      :color="getParam('color')"
      :type="getParam('type')"
      :elevation="getParam('elevation')"
      dismissible
      v-if="isShowMessage"
    >
      <template slot="close">
        <v-btn
          elevation="2"
          outlidned
          :loading="loading"
          :disabled="loading"
          class="v-btn--rounded ml-2"
          x-small
          @click="closeMessage"
          fabb
          :color="getParam('closeColor')"
          :title="$t('components.helpers.closeMessages.hideAndClose')"
          icon
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
      </template>
      {{ messages[type].text }}
    </v-alert>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { USER_REQUEST } from "@/store/actions/user";
import { apiCallTrue } from "@/utils/api";
import showNotify from "@/services/noty";
import i18n from "@/services/i18n";

export default {
  name: "CloseMessages",
  data: () => ({
    loading: false,
    forceHide: false,
    messages: {
      //client, physical
      1: {
        text: i18n.t('components.helpers.closeMessages.messages.1'),
        border: "bottom",
        coloredBorder: true,
        type: "warning",
        closeColor: "orange",
        elevation: 2,
      },
      //client add
      2: {
        text: i18n.t('components.helpers.closeMessages.messages.2'),
        border: "left",
        coloredBorder: true,
        type: "warning",
        closeColor: "orange",
        elevation: 2,
      },
      //client list
      3: {
        text: i18n.t('components.helpers.closeMessages.messages.3'),
        border: "bottom",
        coloredBorder: true,
        type: "warning",
        closeColor: "orange",
        elevation: 2,
      },
      //client edit
      4: {
        text: i18n.t('components.helpers.closeMessages.messages.4'),
        border: "bottom",
        coloredBorder: true,
        type: "warning",
        closeColor: "orange",
        elevation: 2,
      },
      5: {
        text: i18n.t('components.helpers.closeMessages.messages.5'),
        border: "left",
        coloredBorder: true,
        type: "warning",
        closeColor: "orange",
        elevation: 2,
      },
    },
  }),
  props: {
    type: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    ...mapState({
      profile: (state) => state.user.profile,
    }),

    isShowMessage() {
      if (this.forceHide) return false;
      if(!this.profile) return false;
      if (
        this.profile.settings &&
        this.profile.settings.close_messages
      ) {
        if (this.profile.settings.close_messages.includes(this.type))
          return false;
      }
      return true;
    },
  },

  methods: {
    getParam(paramName) {
      if (this.messages[this.type]) return this.messages[this.type][paramName];
      return null;
    },

    async closeMessage() {
      this.loading = true;
      const data = {
        type_id: this.type,
      };
      await apiCallTrue({
        url: `v1/users/close-message`,
        method: "POST",
        data,
      })
        .then((response) => {
          console.log("RESP", response);
          this.forceHide = true;
          if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch(USER_REQUEST);
          }
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
</style>
